window.scrollToElement = (selector, yOffset = 0, delay = 0) => {
    const el = document.querySelector(selector);
    const navbarOffset = document.querySelector('.topBar').offsetHeight || 0;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset - navbarOffset;

    if (delay) {
        setTimeout(() => {
            window.scrollTo({
                top: y, 
                behavior: 'smooth',
            });
        }, delay);
    } 
    else {
        window.scrollTo({
            top: y, 
            behavior: 'smooth',
        });
    }
    
}



//////////////////
// WEBPACK FOOTER
// ./js/modules/scrollToElement.js
// module id = 23
// module chunks = 0